import React, { useContext, useEffect, useState } from 'react';
import DashboardLayout from '../../../layout/dashboard/dashboardLayout';
import './styles/index.css';
import { RavenButton, RavenModal, toast } from '@ravenpay/raven-bank-ui';
import EmptyBankBoxOverview from './components/overview/EmptyOverview';
import BankBoxMainOverview from './components/overview';
import { getCookie, mapHotkey, setCookie } from '../../../utils/helper/Helper';
import SetupBankbox from './components/modals/SetupBankbox';
import RootState, { ActivateBankBoxPayload } from '../../../redux/types';
import { useDispatch, useSelector } from 'react-redux';
import ActionContext from '../../../context/ActionContext';
import { bankboxAPI } from '../../../redux/bankbox';
// import { getSettingsConfig } from '../../../redux/settings';

const BankBoxOverview = () => {
	return (
		<>
			<DashboardLayout>
				<BankBoxMainOverview />
			</DashboardLayout>
		</>
	);
};

export default BankBoxOverview;
